export const STATE_SCALES = Object.freeze({
  relax: Object.freeze({
    question: "Comment vous sentez-vous ?",
    leftLabel: "Sous pression",
    rightLabel: "Plus apaisé",
  }),
  rest: Object.freeze({
    question: "Où en êtes-vous ?",
    leftLabel: "Encore très actif",
    rightLabel: "Prêt à ralentir",
  }),
  recenter: Object.freeze({
    question: "Comment est votre attention ?",
    leftLabel: "Très dispersée",
    rightLabel: "Plus claire",
  }),
});

export function getStateScale(intent) {
  return STATE_SCALES[intent] || STATE_SCALES.relax;
}
